import VideoHero from "@/components/landing/VideoHero";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import SEOContent from "@/components/landing/SEOContent";
import { Helmet } from "react-helmet-async";

const SUPABASE_URL = "https://xvsccalbqvonwxyigifr.supabase.co";
const VIDEO_URL = `${SUPABASE_URL}/storage/v1/object/public/video/Final%20video.mp4`;

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Free Resume Builder & CV Maker with AI | ATS Optimized</title>
        <meta name="description" content="Free AI resume builder & CV maker with ATS score checker. 50+ templates, job tracker, interview prep. Optimize your resume for ATS. Start free today!" />
        <link rel="canonical" href="https://aicvwala.com" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Free Resume Builder & CV Maker with AI | ATS Optimized" />
        <meta property="og:description" content="Free AI resume builder & CV maker with ATS score checker. 50+ templates, job tracker, interview prep. Optimize your resume for ATS. Start free today!" />
        <meta property="og:url" content="https://aicvwala.com" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://aicvwala.com/images/aicvwala-hero.png" />
        <meta property="og:site_name" content="AI CV WALA" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Free Resume Builder & CV Maker with AI | ATS Optimized" />
        <meta name="twitter:description" content="Free AI resume builder & CV maker with ATS score checker. 50+ templates, job tracker, interview prep. Optimize your resume for ATS. Start free today!" />
        <meta name="twitter:image" content="https://aicvwala.com/images/aicvwala-hero.png" />
        
        {/* Schema 0: WebSite */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "AI CV WALA",
            "alternateName": ["AI CV WALA Resume Builder", "AICVWALA", "Resume Builder AI"],
            "url": "https://aicvwala.com",
            "description": "Free AI-powered resume builder with ATS optimization, CV maker, and job application tracker"
          })}
        </script>
        
        {/* Schema 1: Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "AI CV WALA",
            "url": "https://aicvwala.com",
            "logo": "https://aicvwala.com/logo.png",
            "description": "AI-powered resume builder and career development platform",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "IN",
              "addressRegion": "Karnataka",
              "postalCode": "560068"
            },
            "telephone": "+91-8474001401",
            "sameAs": [
              "https://www.linkedin.com/company/aicvwala",
              "https://twitter.com/aicvwala"
            ]
          })}
        </script>
        
        {/* Schema 2: SoftwareApplication + Product (Service) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": ["SoftwareApplication", "Product"],
            "name": "AI CV WALA Resume Builder",
            "applicationCategory": "BusinessApplication",
            "operatingSystem": "Web Browser",
            "url": "https://aicvwala.com",
            "description": "Free AI-powered resume builder with ATS optimization and 50+ professional templates",
            "image": "https://aicvwala.com/images/aicvwala-hero.png",
            "brand": {
              "@type": "Brand",
              "name": "AI CV WALA"
            },
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "INR",
              "availability": "https://schema.org/InStock",
              "priceValidUntil": "2026-12-31",
              "url": "https://aicvwala.com",
              "itemCondition": "https://schema.org/NewCondition",
              "seller": {
                "@type": "Organization",
                "name": "AI CV WALA"
              }
            },
            "shippingDetails": {
              "@type": "OfferShippingDetails",
              "shippingRate": {
                "@type": "MonetaryAmount",
                "value": "0",
                "currency": "INR"
              },
              "deliveryTime": {
                "@type": "ShippingDeliveryTime",
                "handlingTime": {
                  "@type": "QuantitativeValue",
                  "minValue": "0",
                  "maxValue": "0",
                  "unitCode": "MIN"
                },
                "transitTime": {
                  "@type": "QuantitativeValue",
                  "minValue": "0",
                  "maxValue": "0",
                  "unitCode": "MIN"
                }
              },
              "shippingDestination": {
                "@type": "DefinedRegion",
                "addressCountry": "*"
              }
            },
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "*",
              "returnPolicyCategory": "https://schema.org/MerchantReturnNotPermitted",
              "merchantReturnDays": "0",
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/FreeReturn",
              "itemCondition": "https://schema.org/NewCondition"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "12453",
              "bestRating": "5",
              "worstRating": "1"
            },
            "review": [
              {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Sarah Chen"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": "5",
                  "bestRating": "5"
                },
                "reviewBody": "Best resume builder I've used! Got 3 interviews within a week."
              },
              {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Rahul Sharma"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": "5",
                  "bestRating": "5"
                },
                "reviewBody": "The ATS optimization feature helped me land my dream job at a top MNC."
              }
            ],
            "featureList": [
              "ATS Score Checker",
              "Resume Templates",
              "Job Application Tracker",
              "Interview Practice",
              "Career Advisor",
              "AI Writing Assistant"
            ]
          })}
        </script>
        
        
        {/* Schema 4: FAQPage (Enhanced with 10 Questions) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Is AI CV WALA resume builder completely free?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes! AI CV WALA offers a completely free resume builder with AI assistance, ATS optimization, and access to 50+ professional templates. No credit card required to get started. You can create unlimited resume versions, download as PDF, and share directly to WhatsApp or Gmail at no cost."
                }
              },
              {
                "@type": "Question",
                "name": "What is ATS and why does it matter for my resume?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "ATS (Applicant Tracking System) is software used by 90% of companies to automatically screen resumes before human review. Our ATS optimizer ensures your resume passes these automated filters and reaches hiring managers. AI CV WALA provides real ATS compatibility scores to help you improve your resume's chances of passing automated screening."
                }
              },
              {
                "@type": "Question",
                "name": "Can I search for jobs in the platform?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes! Our Job Search feature provides access to live job listings from LinkedIn, Indeed, and other platforms. You can filter by salary, skills, location, and experience level to find your perfect role. Search through thousands of real-time job openings tailored to your profile."
                }
              },
              {
                "@type": "Question",
                "name": "How do I track my job applications?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Use our Application Tracker to manage all your job applications in one dashboard. Track application status, set follow-up reminders, monitor interview pipelines, and organize your entire job search. Never miss a deadline or forget to follow up on important applications again."
                }
              },
              {
                "@type": "Question",
                "name": "What makes AI CV WALA different from other platforms?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "AI CV WALA uniquely combines three powerful tools in one platform: resume building, job search, and application tracking. With AI writing assistance, real ATS testing, and intelligent job matching features, you get a complete career solution all in one place. Unlike competitors that focus on just one feature, we provide an integrated approach to job hunting success."
                }
              },
              {
                "@type": "Question",
                "name": "How many resume templates does AI CV WALA offer?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We offer 50+ professional resume templates across four categories: Modern, Classic, Creative, and ATS-Optimized. Each template is designed by HR experts and tested against real ATS systems. Whether you're applying for a startup tech role, corporate position, or creative job, we have the perfect template for you."
                }
              },
              {
                "@type": "Question",
                "name": "Can I download my resume as PDF?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, you can download your completed resume as a professional PDF file, optimized for both digital submission and printing. You can also share directly via WhatsApp, Gmail, or LinkedIn. All downloads are in high-quality formats ready for immediate use."
                }
              },
              {
                "@type": "Question",
                "name": "How does the AI resume writer help me?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Our AI analyzes your experience and target job descriptions to suggest powerful bullet points, optimize keywords, and improve your resume's impact. It enhances your content while maintaining your authentic voice. Get AI-powered suggestions for every section of your resume to maximize your chances of landing interviews."
                }
              },
              {
                "@type": "Question",
                "name": "Can I import my existing resume?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Absolutely! AI CV WALA supports OCR import from PDF and image files (PNG, JPG, WEBP). Simply upload your existing resume and our AI will extract and organize your information automatically. Your data is processed securely and you can edit everything before downloading your new, optimized resume."
                }
              },
              {
                "@type": "Question",
                "name": "Is my data secure on AI CV WALA?",
                "answerCount": 1,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we take data security seriously. Your resume data is encrypted and stored securely on our servers. We never share your personal information with third parties without your explicit consent. All data transfers use SSL encryption to protect your privacy."
                }
              }
            ]
          })}
        </script>
        
        {/* Schema 3: Product Schema - ATS Score Checker */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "ATS Score Checker Tool",
            "description": "Free AI-powered ATS score analyzer for resume optimization. Check if your resume passes applicant tracking systems.",
            "url": "https://aicvwala.com/ats-score-checker",
            "image": "https://aicvwala.com/images/ats-checker.png",
            "brand": {
              "@type": "Brand",
              "name": "AI CV WALA"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "5230",
              "bestRating": "5",
              "worstRating": "1"
            },
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "INR",
              "availability": "https://schema.org/InStock",
              "priceValidUntil": "2026-12-31",
              "url": "https://aicvwala.com/ats-score-checker",
              "itemCondition": "https://schema.org/NewCondition"
            },
            "shippingDetails": {
              "@type": "OfferShippingDetails",
              "shippingRate": {
                "@type": "MonetaryAmount",
                "value": "0",
                "currency": "INR"
              },
              "deliveryTime": {
                "@type": "ShippingDeliveryTime",
                "handlingTime": {
                  "@type": "QuantitativeValue",
                  "minValue": "0",
                  "maxValue": "0",
                  "unitCode": "MIN"
                },
                "transitTime": {
                  "@type": "QuantitativeValue",
                  "minValue": "0",
                  "maxValue": "0",
                  "unitCode": "MIN"
                }
              },
              "shippingDestination": {
                "@type": "DefinedRegion",
                "addressCountry": "*"
              }
            },
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "*",
              "returnPolicyCategory": "https://schema.org/MerchantReturnNotPermitted",
              "merchantReturnDays": "0",
              "returnFees": "https://schema.org/FreeReturn"
            }
          })}
        </script>
        
        {/* Schema 5: Breadcrumbs */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://aicvwala.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Resume Builder",
                "item": "https://aicvwala.com/resume-builder"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Job Search",
                "item": "https://aicvwala.com/job-search"
              },
              {
                "@type": "ListItem",
                "position": 4,
                "name": "Job Tracker",
                "item": "https://aicvwala.com/job-tracker"
              }
            ]
          })}
        </script>
        
        {/* Schema 6: LocalBusiness */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "AI CV WALA",
            "image": "https://aicvwala.com/logo.png",
            "description": "Professional AI-powered resume builder and career development platform",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "560068",
              "addressLocality": "Bengaluru",
              "addressRegion": "Karnataka",
              "postalCode": "560068",
              "addressCountry": "IN"
            },
            "url": "https://aicvwala.com",
            "telephone": "+91-8XXX-XXX-XXX",
            "email": "support@aicvwala.com",
            "serviceType": [
              "Resume Writing",
              "Career Coaching",
              "Job Application Assistance",
              "ATS Optimization"
            ],
            "areaServed": ["IN", "US", "GB", "CA", "AU"],
            "priceRange": "Free - ₹199",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "ratingCount": "12453",
              "bestRating": "5",
              "worstRating": "1"
            }
          })}
        </script>
      </Helmet>
      
      <main className="overflow-x-hidden">
        <Navbar />
        <VideoHero videoSrc={VIDEO_URL} />
        <SEOContent />
        <Footer />
      </main>
    </>
  );
};

export default Index;
